/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `from_column` - From column
* `from_import` - From import
* `not_assigned` - Not assigned
 */
export type SiteSourceEnum = typeof SiteSourceEnum[keyof typeof SiteSourceEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteSourceEnum = {
  from_column: 'from_column',
  from_import: 'from_import',
  not_assigned: 'not_assigned',
} as const;
